// extracted by mini-css-extract-plugin
module.exports = {"base":"Checkbox_base__SSC6t","input":"Checkbox_input__3UVZJ","error":"Checkbox_error__2xVkk"};